var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Course from "../models/Course";
import CourseSchedule from "../models/CourseSchedule";
export default class StudentService {
    /**
     * Fetches the current student's course schedule.
     *
     * @param {string} studentId - The ID of the student for whom to load the current course
     * schedule. If null, assumes the current user is the student.
     */
    static fetchCurrentSchedule(studentId) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = "/aviso/student/currentTerm";
            if (studentId) {
                url += `?studentId=${studentId}`;
            }
            const response = yield fetch(url, { credentials: "include" });
            const courses = yield response.json();
            // Convert the resulting data to typed objects.
            // @ts-expect-error - TS7006 - Parameter 'c' implicitly has an 'any' type.
            const result = courses.map((c) => {
                const course = new Course();
                course.id = c.id;
                course.code = c.code;
                if (c.courseSectionScheduleElements) {
                    course.courseSectionScheduleElements =
                        c.courseSectionScheduleElements.map(
                        // @ts-expect-error - TS7006 - Parameter 'cse' implicitly has an 'any' type.
                        (cse) => {
                            const schedule = new CourseSchedule();
                            schedule.id = cse.id;
                            schedule.location = cse.location;
                            schedule.meetingType = cse.meetingType;
                            schedule.room = cse.room;
                            schedule.startTimeHours24 = cse.startTimeHours24;
                            schedule.startTimeMinutes24 = cse.startTimeMinutes24;
                            schedule.endTimeHours24 = cse.endTimeHours24;
                            schedule.endTimeMinutes24 = cse.endTimeMinutes24;
                            schedule.monday = cse.monday;
                            schedule.tuesday = cse.tuesday;
                            schedule.wednesday = cse.wednesday;
                            schedule.thursday = cse.thursday;
                            schedule.friday = cse.friday;
                            schedule.saturday = cse.saturday;
                            return schedule;
                        });
                }
                return course;
            });
            return result;
        });
    }
}
